import { createTheme } from '@mui/material/styles'
import '@mui/x-date-pickers/themeAugmentation'

import { resolveEffectiveBranding } from '../branding/resolveEffectiveBranding'
import type { EffectiveBranding } from '../branding/types'
import '../branding/fonts'
import './themeAugmentation'

import { breakpointValues } from './breakpoints'
import { createComponentOverrides } from './componentOverrides'
import { buildThemePalette, buildThemeTypography } from './palette'

export interface CreateAppThemeOptions {
  branding?: EffectiveBranding
}

export const createAppTheme = (options?: CreateAppThemeOptions) => {
  const branding = options?.branding ?? resolveEffectiveBranding(null)

  return createTheme({
    palette: buildThemePalette(branding),
    typography: buildThemeTypography(branding),
    breakpoints: {
      values: breakpointValues,
    },
    components: createComponentOverrides(),
  })
}

const theme = createAppTheme()

export default theme

export {
  INPUT_BORDER_RADIUS,
  MULTILINE_TEXT_MOBILE_BORDER_RADIUS,
  PAGE_TOP_PADDING,
  PAGE_BOTTOM_PADDING,
  FOOTER_HEIGHT,
  PAGE_MAX_WIDTH,
  PAGE_WIDTH,
  HEADER_HEIGHT,
  HEADER_BANNER_HEIGHT,
  BEACH_PLAN_HEIGHT,
} from './layoutConstants'
